<div class="w-full p-6">
  <div class="max-h-[80vh] overflow-y-auto pr-2">
    <h3 class="titre3">{{ 'USERS_MANAGEMENT.CREATE_SSO_USER_TITLE' | translate }}</h3>

    <div class="mb-4 mt-2">
      <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.VIEWING_ENTITY' | translate }}</span>
      @if (entiteUnique) {
        <div>
          <span class="text-sm font-semibold">{{entiteUnique.nom}}</span>
        </div>
      } @else {
        <select title="entite" id="selecteur-entite" [(ngModel)]="entiteSelectionnee"
          (change)="onEntiteSelectionnee($event)" class="w-full p-2 border rounded"
          [attr.aria-label]="'USERS_MANAGEMENT.SELECT_ENTITY' | translate ">
          @for (entite of entites; track entite) {
            <option [value]="entite.id">{{entite.nom}}</option>
          }
        </select>
      }
    </div>

    <div class="mb-4 mt-2">
      <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.TAGS' | translate }}</span>
      <select #etiquetteSelect title="TAGS" id="etiquettes"
        (change)="onEtiquetteSelectionnee($event, etiquetteSelect)" class="w-full p-2 border rounded">
        <option value="">{{ 'USERS_MANAGEMENT.SELECT_TAG' | translate }}</option>
        @for (etiquette of etiquettesDisponibles; track etiquette) {
          <option [value]="etiquette.etiquetteId">
            {{ etiquetteService.getNomLocalise(etiquette.locales) }}
          </option>
        }
      </select>

      @if (etiquettesSelectionnees.length > 0) {
        <div class="mt-3">
          <div class="titre4Modal">{{ 'USERS_MANAGEMENT.SELECTED_TAGS' | translate }}:</div>
          <ul class="list-disc list-inside">
            @for (etiquette of etiquettesSelectionnees; track etiquette) {
              <li>
                {{ etiquetteService.getNomLocalise(etiquette.locales) }}
                <button (click)="supprimerEtiquetteSelectionnee(etiquette.etiquetteId)"
                  class="ml-2 text-rougeNovo">
                  {{ 'USERS_MANAGEMENT.REMOVE' | translate }}
                </button>
              </li>
            }
          </ul>
        </div>
      }
    </div>

    <div class="mb-4">
      <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.CREATION_METHOD' | translate }}</span>
      <select id="selecteur-methode-creation" [(ngModel)]="methodeCreation" class="w-full p-2 border rounded">
        <option value="manual">{{ 'USERS_MANAGEMENT.MANUAL_ADDITION' | translate }}</option>
        <option value="excel">{{ 'USERS_MANAGEMENT.IMPORT_FROM_EXCEL' | translate }}</option>
      </select>
    </div>

    @if (methodeCreation === 'excel') {
      <div class="mb-6">
        <div class="mb-4">
          <button class="px-4 py-2 btn-primary-novo" (click)="telechargerModeleExcel()">{{
          'USERS_MANAGEMENT.DOWNLOAD_EXCEL_TEMPLATE' | translate }}</button>
        </div>
        <div class="mb-4">
          <input type="file" (change)="onFichierSelectionne($event)" accept=".xlsx, .xls"
            title="{{ 'USERS_MANAGEMENT.SELECT_EXCEL_FILE' | translate }}" class="text-sm" />
            <p class="text-xs text-gray-500 mt-1 italic">{{ 'USERS_MANAGEMENT.EXCEL_COLUMNS_REQUIRED' | translate }}
            </p>
          </div>
          @if (utilisateursExcel.length > 0) {
            <div class="overflow-x-auto mt-4 max-h-80 overflow-y-auto">
              <table class="mat-table-novo divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col"
                      class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {{ 'USERS_MANAGEMENT.FIRST_NAME' | translate }}
                    </th>
                    <th scope="col"
                      class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {{ 'USERS_MANAGEMENT.LAST_NAME' | translate }}
                    </th>
                    <th scope="col"
                      class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {{ 'USERS_MANAGEMENT.EMAIL' | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody class="mat-table-novo divide-y divide-gray-200">
                  @for (user of utilisateursExcel; track user) {
                    <tr>
                      <td class="px-4 py-2 whitespace-nowrap text-xs text-gray-900">
                        {{user.prenom}}
                      </td>
                      <td class="px-4 py-2 whitespace-nowrap text-xs text-gray-900">
                        {{user.nom}}
                      </td>
                      <td class="px-4 py-2 whitespace-nowrap text-xs text-gray-900">
                        {{user.courriel}}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @if (utilisateursExcel.length === 0 && fichierSelectionne) {
            <div class="mt-4 text-rougeNovo">
              {{ 'USERS_MANAGEMENT.NO_USERS_IN_FILE' | translate }}
            </div>
          }
        </div>
      }

      @if (methodeCreation === 'manual') {
        <div class="mb-4">
          <div class="grid grid-cols-2 gap-4">
            <div>
              <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.FIRST_NAME' | translate }}</span>
              <input class="w-full p-2 border rounded dark:text-gray-800"
                placeholder="{{ 'USERS_MANAGEMENT.FIRST_NAME' | translate }}"
                [(ngModel)]="utilisateurManuel.prenom">
              </div>
              <div>
                <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.LAST_NAME' | translate }}</span>
                <input class="w-full p-2 border rounded dark:text-gray-800"
                  placeholder="{{ 'USERS_MANAGEMENT.LAST_NAME' | translate }}"
                  [(ngModel)]="utilisateurManuel.nom">
                </div>
              </div>
              <div class="mt-4">
                <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.EMAIL' | translate }}</span>
                <input type="email" class="w-full p-2 border rounded dark:text-gray-800"
                  placeholder="{{ 'USERS_MANAGEMENT.EMAIL' | translate }}" [(ngModel)]="utilisateurManuel.courriel">
                </div>
              </div>
            }

            <div class="flex justify-end mt-4">
              <button (click)="onAnnuler()" type="button" class="btn-secondary-novo">
                {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
              </button>
              <button (click)="onConfirmer()" type="submit"
                class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed"
                [disabled]="boutonCreerDesactive() || chargementEnCours">
                @if (!chargementEnCours) {
                  <span>{{ 'USERS_MANAGEMENT.CREATE' | translate }}</span>
                }
                @if (chargementEnCours) {
                  <mat-spinner [diameter]="24" [color]="'accent'"></mat-spinner>
                }
              </button>
            </div>
          </div>
        </div>